import React, { useMemo } from 'react';
import { FocusVersionScheduling } from '@/redux/slices/slice_types';
import { Button, ButtonOwnProps } from '@mui/material';
import { PolarisIcon } from '@/exports/columnCommonComponents';
import { useAppSelector } from '@/redux/hooks';
import { selectAvailPlatformIds, selectRawCustomerList } from '@/redux/selectors/constantsSelectors';

type ViewPolarisJobsButtonProps = {
  schedule: FocusVersionScheduling;
  variant?: ButtonOwnProps['variant'];
  color?: ButtonOwnProps['color'];
  width?: string;
  className?: string;
};

const ViewPolarisJobsButton = ({ schedule, variant = 'text', color = 'primary', width, className }: ViewPolarisJobsButtonProps) => {
  const status = schedule.status ?? 'completed';
  const clientPolarisIds = useAppSelector(selectAvailPlatformIds);
  const customerList = useAppSelector(selectRawCustomerList);

  const platformIds = useMemo(() => {
    if (!schedule.availed_platforms)
      return clientPolarisIds[schedule.availed_platform] ? [clientPolarisIds[schedule.availed_platform].toString()] : undefined;
    const idArray = schedule.availed_platforms
      .map((platform) => (clientPolarisIds[platform] && customerList[clientPolarisIds[platform]] ? clientPolarisIds[platform].toString() : undefined))
      .filter((id) => id !== undefined);
    return idArray.length > 0 ? idArray : undefined;
  }, [schedule.availed_platform, schedule.availed_platforms, clientPolarisIds, customerList]);

  const filtersQueryParamString = useMemo(() => {
    const params = new URLSearchParams();
    params.append(
      'filters',
      JSON.stringify({
        status_filter: ['created', 'in_progress', 'complete'],
        search: schedule.title.client_ids_supplemental.alpha_id,
        customer_filter: platformIds
      })
    );
    return params.toString();
  }, [schedule.title.client_ids_supplemental.alpha_id, platformIds]);
  if (status === 'draft') {
    return (
      <Button startIcon={<PolarisIcon icon="clock" />} variant="outlined" disabled sx={{ width: width || 'auto' }} className={className}>
        Not Available
      </Button>
    );
  }

  return (
    <Button
      component="a"
      href={`/jobs?${filtersQueryParamString}`}
      target="_blank"
      rel="noopener noreferrer"
      variant={variant}
      color={color}
      sx={{ width: width || 'auto' }}
      className={className}
      endIcon={<PolarisIcon icon="right" width={28} height={28} style={{ marginTop: -2, marginBottom: -2, marginRight: -8 }} />}
    >
      View Jobs
    </Button>
  );
};

export default ViewPolarisJobsButton;
